export default __webpack_public_path__ + "static/media/settingsBlack.13c4ee6b.svg";